import { Select } from 'antd';
import { useMemo } from 'react';

import { Divider, Space, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import { memberRoleDic } from '@/stores/WorkspaceStore';

export interface Props {
  selected?: string;
  onSelect: (key: string) => void;
  onRemoveClick: () => void;
}

const RoleDropdown = ({ selected, onSelect, onRemoveClick }: Props) => {
  const roleOptions = [
    ...Object.keys(memberRoleDic).map((key) => {
      const memberKey = Number(key) as MEMBER_ROLE;
      return {
        value: memberKey,
        label: memberRoleDic[memberKey],
        searchName: memberRoleDic[memberKey],
      };
    }),
  ];

  const memberKey = useMemo(() => {
    return Number(selected) as MEMBER_ROLE;
  }, [selected]);

  return (
    <Select
      style={{ width: 120 }}
      options={roleOptions}
      value={memberKey}
      placeholder="Choose role"
      onSelect={(key) => onSelect(String(key))}
      dropdownRender={(node) => {
        return (
          <VFlex>
            {node}
            <Space h={4} />
            <Divider />
            <Space h={4} />
            <Button variant="error_ghost" onClick={onRemoveClick}>
              Remove
            </Button>
          </VFlex>
        );
      }}
    />
  );
};

export default RoleDropdown;
